import React from 'react';
const CarOwner = () => <div style={{padding:32}}>Эзэмшигч (stub)</div>;
export default CarOwner;
